import axios from 'axios';
import QS from 'qs';
import { Loading } from 'element-ui';

if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = 'https://jcjy.laodongjiaoyu.vip/';// https://test.laodongjiaoyu.vip
}// https://test.laodongjiaoyu.vip/
else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = 'https://jcjy.laodongjiaoyu.vip/';
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'https://jcjy.laodongjiaoyu.vip/';
}
// axios.defaults.baseURL = 'https://jcjy.laodongjiaoyu.vip/';

const token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post.token = token;

 // 响应拦截器
axios.interceptors.response.use(
    (response) => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展

    (error) => {
        if (error.response.status) {
            switch (error.response.status) {

            }
            return Promise.reject(error.response);
        }
    }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  const loading = Loading.service({
    lock: true,
    text: '加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  });
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params,
        }).then((res) => {
            setTimeout(() => {
              loading.close();
            }, 1000);
            resolve(res.data);
        }).catch((err) => {
            setTimeout(() => {
              loading.close();
            }, 1000);
            reject(err.data);
        });
    });
}


/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  const loading = Loading.service({
    lock: true,
    text: '加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  });
    return new Promise((resolve, reject) => {
         axios.post(url, QS.stringify(params))
        .then((res) => {
            setTimeout(() => {
              loading.close();
            }, 1000);
            resolve(res.data);
        })
        .catch((err) => {
            setTimeout(() => {
              loading.close();
            }, 1000);
            reject(err.data);
        });
    });
}

export function updateHeaders(key, params) {
	axios.defaults.headers.post[key] = params;
}



// WEBPACK FOOTER //
// ./src/request/http.js